export interface IImomoErrorService {
  showMissingStationErrorDialog(stationCode:string):ng.IPromise<any>;
  showForbiddenStationErrorDialog(stationCode:string):ng.IPromise<any>;
  showGenericErrorDialog():ng.IPromise<any>;
  showErrorDetailsDialog(errorMsg: string):ng.IPromise<any>;
}

export default class ImomoErrorService implements IImomoErrorService {
  static $inject = ['$mdDialog', '$translate'];

  constructor(private $mdDialog:ng.material.IDialogService,
              private $translate:ng.translate.ITranslateService) {

  }

  showMissingStationErrorDialog(stationCode:string) {
    const dialog = this.$mdDialog.alert()
        .title(this.$translate.instant(
            'NON_EXISTENT_STATION_CODE'))
        .textContent(this.$translate.instant(
            'NON_EXISTENT_STATION_CODE_EXTENDED', {stationCode}))
        .ok(this.$translate.instant(
            'OK'));
    return this.$mdDialog.show(dialog);
  }

  showForbiddenStationErrorDialog(stationCode:string) {
    const dialog = this.$mdDialog.alert()
        .title(this.$translate.instant(
            'FORBIDDEN_STATION_CODE'))
        .textContent(this.$translate.instant(
            'FORBIDDEN_STATION_CODE_EXTENDED', {stationCode}))
        .ok(this.$translate.instant(
            'OK'));
    return this.$mdDialog.show(dialog);
  }

  showErrorDetailsDialog(errorMsg: string) {
    const dialog = this.$mdDialog.alert()
        .title(this.$translate.instant(
            'ERROR'))
        .textContent(errorMsg)
        .ok(this.$translate.instant(
            'OK'));
    return this.$mdDialog.show(dialog);
  }

  showGenericErrorDialog() {
    const dialog = this.$mdDialog.alert()
        .title(this.$translate.instant(
            'UNEXPECTED_ERROR'))
        .textContent(this.$translate.instant(
            'UNEXPECTED_ERROR_EXTENDED'))
        .ok(this.$translate.instant(
            'TRY_AGAIN'));
    return this.$mdDialog.show(dialog);
  }
}



/** WEBPACK FOOTER **
 ** ./app/error/error.service.ts
 **/